import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserResetPassword = {
  userResetPassword: { data: null, loading: false, error: null },
};

export const userResetPassword = createAsyncThunk('user/userResetPassword', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/user/reset-password`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserResetPassword = {
  [userResetPassword.pending]: (state) => {
    state.userResetPassword.loading = true;
  },
  [userResetPassword.fulfilled]: (state, action) => {
    state.userResetPassword.loading = false;
    state.userResetPassword.data = action.payload;
    state.userResetPassword.error = null;
  },
  [userResetPassword.rejected]: (state, action) => {
    state.userResetPassword.loading = false;
    state.userResetPassword.error = action.payload;
  },
};
